import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { ILoadBulkImportEmployeesResponse } from '../models/bulk-import-employees.model';

export const undoSelectedEmployeeUpdatesKey = 'undoSelectedEmployeeUpdates';

export interface UndoSelectedEmployeeUpdatesState {
  undoSelectedEmployeeUpdatesResponse: any;
  undoSelectedEmployeeUpdatesFailure: any;
  loaded: boolean;
}

export const initialState: UndoSelectedEmployeeUpdatesState = {
  undoSelectedEmployeeUpdatesResponse: undefined,
  undoSelectedEmployeeUpdatesFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(actions.undoSelectedUpdatesSuccess, (state, action) => ({
    ...state,
    undoSelectedEmployeeUpdatesResponse: action.response,
    loaded: true
  })),

  on(actions.undoSelectedUpdatesFailure, (state, action) => ({
    ...state,
    undoSelectedEmployeeUpdatesFailure: action.error
  }))
);

export const undoSelectedEmployeeUpdates = (state: UndoSelectedEmployeeUpdatesState) => state.undoSelectedEmployeeUpdatesResponse;
